import React, { useState, useContext } from "react";
import { AnswersContext } from "../../context/AnswersContext";
import parse from "html-react-parser";
import "../../sass/blocks/_contest-question.scss";

const ContestQuestionUserAnswers = (props) => {
    const {
        title,
        instruction,
        content,
        post_id,
        question_id,
        users_answers_only_img,
    } = props.question;

    const { index, prevQuestionHandler, nextQuestionHandler } = props;
    const { answers, setAnswers } = useContext(AnswersContext);

    const [inputsValue, setInputsValue] = useState({
        firstAnswer: {
            page_id: post_id,
            answer: "",
            weight: 5,
            answer_id: 0,
            question_id: question_id,
        },
        secondAnswer: {
            page_id: post_id,
            answer: "",
            weight: 4,
            answer_id: 0,
            question_id: question_id,
        },
        thirdAnswer: {
            page_id: post_id,
            answer: "",
            weight: 3,
            answer_id: 0,
            question_id: question_id,
        },
        fourthAnswer: {
            page_id: post_id,
            answer: "",
            weight: 2,
            answer_id: 0,
            question_id: question_id,
        },
        fifthAnswer: {
            page_id: post_id,
            answer: "",
            weight: 1,
            answer_id: 0,
            question_id: question_id,
        },
    });

    const updateAnswers = (e) => {
        const filteredAnswers = answers.filter(
            (answer) => answer.question_id !== question_id
        );

        const newAnswers = [];

        Object.keys(inputsValue).forEach((key) => {
            if (inputsValue[key].answer.length > 0) {
                newAnswers.push(inputsValue[key]);
            }
        });

        const combinedAnserws = filteredAnswers.concat(newAnswers);
        setAnswers(combinedAnserws);
        nextQuestionHandler();
    };

    const handleInputChange = (e) => {
        setInputsValue({
            ...inputsValue,
            [e.target.name]: {
                ...inputsValue[e.target.name],
                answer: e.target.value,
            },
        });
    };

    const Inputs = Object.keys(inputsValue).map((key) => (
        <div className="input-group">
            <input
                className="input-group__input"
                name={key}
                autoComplete="off"
                id="firstAnswer"
                onChange={handleInputChange}
                placeholder="Pierwsza sugestia"
                value={inputsValue[key].answer}
            ></input>
            <label className="input-group__line"></label>
            <span
                className={`input-group__number ${
                    users_answers_only_img &&
                    "contest-input__number--img-enabled"
                }`}
            >
                {inputsValue[key].weight}&nbsp;pkt.
            </span>
            {users_answers_only_img && (
                <img
                    className="contest-input__img"
                    src={users_answers_only_img}
                />
            )}
        </div>
    ));

    return (
        <>
            <div className="contest-question__container-head contest-question__container-head--index">
                <h2
                    style={{ background: props.background }}
                    className="contest-question__heading contest-question__heading--index"
                >
                    {index * 1 + 1}
                    <b>/{props.questionsLength}</b>
                </h2>
            </div>

            <div className="contest-question__container-head">
                <h2 className="contest-question__heading">{title}</h2>
            </div>

            <div className="contest-question__desc">{content}</div>

            {instruction.length > 0 && (
                <p className="contest-question__instruction">
                    {parse(instruction)}
                </p>
            )}

            {Inputs.length > 0 && Inputs}

            <div className="contest-question-flex">
                {index > 0 && (
                    <button
                        className="contest-question-flex__button"
                        onClick={prevQuestionHandler}
                    >
                        Powrót
                    </button>
                )}
                <button
                    className="contest-question-flex__button contest-question-flex__button--next"
                    onClick={updateAnswers}
                >
                    Dalej
                </button>
            </div>
        </>
    );
};

export default ContestQuestionUserAnswers;
